<div mat-dialog-title class="dialog-info d-flex align-items-center justify-content-between horizontal-padding">
    <label class="labelTitle">
       Si-Quote Messenger ({{ data.title }})
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>
<mat-dialog-content class="message-body-container"> 
    <div class="message-body-html" [innerHTML]="renderedBodyHtml" (click)="onBodyClick($event)"></div>
</mat-dialog-content>
<mat-dialog-actions class="message-content-btn" align="end">
   <button class="openCloseBtn" mat-raised-button color="warn" [mat-dialog-close]>Close</button>
</mat-dialog-actions>